/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Header_TitleInputs */

const tr_mascot_chat_header_title = /** @type {(inputs: Mascot_Chat_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx · Destek`)
};

const en_mascot_chat_header_title = /** @type {(inputs: Mascot_Chat_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx · Support`)
};

const de_mascot_chat_header_title = /** @type {(inputs: Mascot_Chat_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx · Support`)
};

const ru_mascot_chat_header_title = /** @type {(inputs: Mascot_Chat_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jinx · Поддержка`)
};

/**
* | output |
* | --- |
* | "Jinx · Support" |
*
* @param {Mascot_Chat_Header_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_header_title = /** @type {((inputs?: Mascot_Chat_Header_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Header_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_header_title(inputs)
	if (locale === "de") return de_mascot_chat_header_title(inputs)
	if (locale === "ru") return ru_mascot_chat_header_title(inputs)
	return tr_mascot_chat_header_title(inputs)
});